export interface GraphQLErrorDetail {
  code: string;
  message: string;
}

export function getErrorDetailsFromGraphQLError(
  error: any,
  knownCodes: string[] = []
): GraphQLErrorDetail[] {
  if (!error) {
    return [];
  }

  const details = extractErrorDetails(error);
  const filteredDetails = details.filter(d => !!d.code);

  if (knownCodes.length === 0) {
    return filteredDetails;
  }

  const knownCodesSet = new Set(knownCodes);

  return filteredDetails.filter(d => knownCodesSet.has(d.code));
}

function extractErrorDetails(error: any): GraphQLErrorDetail[] {
  if (error.graphQLErrors?.length > 0) {
    return extractFromGraphQLErrors(error.graphQLErrors);
  }

  if (error.inner?.length > 0) {
    return error.inner.map((err: any) => ({
      code: err.code ?? '',
      message: err.message ?? '',
    }));
  }

  return [{ code: error.code ?? '', message: error.message ?? '' }];
}

function extractFromGraphQLErrors(gqlErrors: any[]): GraphQLErrorDetail[] {
  const details: GraphQLErrorDetail[] = [];

  for (const gqlError of gqlErrors) {
    details.push(...extractFromSingleGQLError(gqlError));
  }

  return details;
}

function extractFromSingleGQLError(gqlError: any): GraphQLErrorDetail[] {
  const exception = gqlError.extensions?.exception;

  if (exception?.inner?.length > 0) {
    return exception.inner.map((innerErr: any) => ({
      code: innerErr.code ?? '',
      message: innerErr.message ?? gqlError.message ?? '',
    }));
  }

  if (exception?.code) {
    return [
      {
        code: exception.code,
        message: exception.message ?? gqlError.message ?? '',
      },
    ];
  }

  return [{ code: gqlError.code ?? '', message: gqlError.message ?? '' }];
}
